<script>
import DatePicker from 'vue-datepicker-next';
// Locale side-effect imports register the calendar's month/weekday names; the default export is the
// `lang` object we pass to `:lang` so the picker follows the dashboard UI language (e.g. Hebrew).
import enLang from 'vue-datepicker-next/locale/en.es';
import heLang from 'vue-datepicker-next/locale/he.es';

const DATE_PICKER_LANGS = { he: heLang, en: enLang };

export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change'],
  computed: {
    lang() {
      return DATE_PICKER_LANGS[this.$root.$i18n.locale] || enLang;
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      range
      confirm
      :clearable="false"
      :editable="false"
      :lang="lang"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      @change="handleChange"
    />
  </div>
</template>
